import {createRouter, createWebHistory} from 'vue-router'
import {mainStore} from "@/store/main"

const Dashboard = () => import("@/pages/Dashboard")
const News = () => import("@/pages/News")
const Faq = () => import("@/pages/Faq")
const Campaigns = () => import("@/pages/Campaigns")
const Finance = () => import("@/pages/Finance")
const Referrals = () => import("@/pages/Referrals")
const Auth = () => import("@/pages/Auth/index.vue")
const Offers = () => import("@/pages/Offers/index.vue")
const ExportStatistics = () => import("@/pages/ExportStatistics/index.vue")
const ClickIdExport = () => import("@/pages/ClickIdExport/index.vue")
const Unsubscription = () => import("@/pages/Unsubscription/unsubscription.vue")


import {clearLocalStorage, saveTokenFromResponse, saveToken} from "@/helpers";
import {refresh} from "@/api/axios";
import {getClickIdAccess} from "@/api/clickidExport";


const routes = [
    {
        path: '/auth',
        name: 'auth',
        component: Auth,
        meta: {layout: 'login'}
    },
    {
        path: '/unsubscription',
        name: 'unsubscription',
        component: Unsubscription,
        meta: {layout: 'login'}
    },
    {
        path: '/',
        name: 'dashboard',
        component: Dashboard,
        meta: {layout: 'main'}
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: () => import('../pages/Statistics'),
        meta: {layout: 'main'}
    },
    {
        path: '/export',
        name: 'export',
        component: ExportStatistics,
        meta: {layout: 'main'}
    },
    {
        path: '/click-id-export',
        name: 'click-id-export',
        component: ClickIdExport,
        meta: {layout: 'main'}
    },
    {
        path: '/campaigns',
        name: 'campaigns',
        component: Campaigns,
        meta: {layout: 'main'}
    },
    {
        path: '/finance',
        name: 'finance',
        component: Finance,
        meta: {layout: 'main'}
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('../pages/Profile'),
        meta: {layout: 'main'}
    },
    {
        path: '/referrals',
        name: 'referrals',
        component: Referrals,
        meta: {layout: 'main'}
    },
    {
        path: '/news',
        name: 'news',
        component: News,
        meta: {layout: 'main'}
    },
    {
        path: '/faq',
        name: 'faq',
        component: Faq,
        meta: {layout: 'main'}
    },
    {
        path: '/offers',
        name: 'offers',
        component: Offers,
        meta: {layout: 'main'}
    },

]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                el: to.hash,
                behavior: 'smooth',
            }
        } else return {top: 0}
    }
})

async function checkAccess() {
    const token = localStorage.getItem('crm_token');
    const expiring = Number(localStorage.getItem('crm_expire'));

    if (!token || !expiring) {
        return false;
    }
    if (Date.now() < expiring) {
        return true;
    }

    const response = await refresh();
    saveTokenFromResponse(response.data);
    return true;
}

router.beforeEach(async (to, from) => {
    if (to.query.jwt) {
        saveToken(to.query.jwt);
        return {name: 'dashboard', query: {}};
    }

    if (to.name === 'unsubscription') {
        return true;
    }

    try {
        const access = await checkAccess();
        if (to.name === 'auth' && access) {
            return {name: 'dashboard'};
        }
        if (to.name !== 'auth' && !access) {
            return {name: 'auth'};
        }

        const store = mainStore();
        if (access && !store.isClickIdFetch) {
            await getClickIdAccess().then((resp) => {
                store.setClickIdEnabled(resp.data.isAvailable)
            }, () => {
                store.setClickIdEnabled(false)
            })
            if (to.name === 'click-id-export' && access && !store.isClickIdEnabled) {
                return {name: 'dashboard'};
            }
        }

        return true;

    } catch (error) {
        clearLocalStorage();
        return {name: 'auth'};
    }
});
export default router
